import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import ConditionsService from "services/Terms&ConditionsService";

export const initialState = {
  updateLoading: false,
  loadingGetDetails: false,
};

export const GetFirst = createAsyncThunk(
  "/TermsAndConditions/GetFirst",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ConditionsService.GetFirst();
      if (response.success == false) {
        return rejectWithValue(response.message);
      } else {
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const Update = createAsyncThunk(
  "/TermsAndConditions/Update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ConditionsService.Update(data);
      if (response.success == false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: `Success !`,
        });

        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const termsConditionsSlice = createSlice({
  name: "terms&ConditionsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetFirst.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetFirst.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(GetFirst.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(Update.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(Update.rejected, (state, action) => {
        state.updateLoading = false;
      });
  },
});

export const {} = termsConditionsSlice.actions;

export default termsConditionsSlice.reducer;
